import { twoFactor as initialState } from '../initialState.tsx';
import { RECEIVE_USER_LOGIN, RECEIVE_USER_PROFILE } from 'typeConstants';

const twoFactor = (state = initialState, action) => {

  switch (action.type) {
    case RECEIVE_USER_LOGIN:
    case RECEIVE_USER_PROFILE:
      if (action.payload) {
        return {
          ...state,
          authResult: action.payload
        };
      }
      return state;
    default:
      return state;
  }
};

export default twoFactor;
